<template>
  <div id="School-edit">

      <IForm :label-width="80" ref="formInline" :model="edit" :elem="schoolElem" :rules="schoolRule" @on-submit="toSubmit" :submit="false" :showMessage="true">
        <div slot="extend">
          <Row>
            <Col span="12"><FormItem label="学校名称" prop="name"><Input v-model.trim="edit.name" type="text" placeholder="请输入学校名称" maxlength="255"/></FormItem></Col>
            <Col span="12">
              <FormItem label="学校类型" prop="types" :required="true">
                <Select v-model="edit.types" multiple>
                  <Option v-for="item in typeList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="最低年级" prop="lowGradeId">
                <Select v-model="edit.lowGradeId" style="width: 100%;">
                  <Option v-for="item in gradesAll" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="最高年级" prop="higtGradeId">
                <Select v-model="edit.higtGradeId" style="width: 100%;">
                  <Option v-for="item in gradesAll" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="其他年级" prop="otherGradeIds">
                <Select v-model="edit.otherGradeIds" :multiple="true" style="width: 100%;">
                  <Option v-for="item in gradesAll" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="联系人" prop="contactPerson"><Input v-model="edit.contactPerson" type="text" placeholder="请输入联系人" maxlength="50"/></FormItem></Col>
            <Col span="12"><FormItem label="联系电话" prop="telphone"><Input v-model="edit.telphone" type="text" placeholder="请输入联系电话" maxlength="50"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="联系地址" prop="address"><Input v-model="edit.address" type="text" placeholder="请输入联系地址" maxlength="255"/></FormItem></Col>
            <Col span="12">
              <FormItem label="状态" prop="status">
                <Select v-model="edit.status">
                  <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注" prop="remark"><Input v-model="edit.remark" type="textarea" placeholder="请输入备注"/></FormItem>
            </Col>
          </Row>
        </div>
      </IForm>

  </div>
</template>
<script>
import {_get, _save} from "@/services/school/school";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
export default {
  name: "SchoolEdit",
  mixins: [mixins],
  data() {
    return {
      typeList :[
        {name: '幼儿园', code: "1"},
        {name: '小学', code: "2"},
        {name: '初中', code: "3"},
        {name: '高中', code: "4"},
        {name: '大学', code: "5"},
      ],
      enums:enums,
      edit: {
        name: "",
        types: "",
        lowGradeId: "",
        higtGradeId: "",
        otherGradeIds: [],
        contactPerson: "",
        address: "",
        telphone: "",
        remark: "",
        status: 1
      },
      init: "",
      schoolElem: [],
      schoolRule: {
        name: [
          {required: true, message: '学校名称不能为空', trigger: 'blur'},
          {maxlength:50,message:"学校名称长度不能超过50个字",trigger: 'blur'}
        ],
        types: [
          {validator:function(rule, value, callback){
              if (!value || value.length == 0) {
                callback(new Error('请选择学校类型'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' }
        ],
        lowGradeId: [
          {
            required: true,
            message: "请选择最低年级",
            type:'number'
          }
        ],
        higtGradeId: [
          {
            required: true,
            message: "请选择最高年级",
            type:'number'
          }
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type:'number'
          }
        ]
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
    this.applyGradesAll();
  },
  methods: {
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      _get({id: row.id}).then(res =>{
        row = res.data;
        const edit = Object.assign({}, row);
        edit.types = edit.type.toString().split(",");
        this.edit = {
          ...edit,
        };
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      const payload = {
        ...this.edit,
      }
      payload.type = payload.types.toString();
      delete payload.types;
      _save(payload).then(res => {
          if (res.errcode === 1) {
            this.$message.success("保存成功");
            this.$emit("on-submit", false);
          }else{
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
